import {Badge} from "@vacasa/react-components-lib";
import React from "react";
import {PillsInput, PillsInputCallbackType} from "../../index";
import style from "./EmailHeader.module.scss";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../store/store";
import {setEmailData} from "../../../store/cancellationWorkflowSlice";

export const EmailHeader: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const reservation = useSelector((state: RootState) => state.cancellationWorkflow.reservation);
  const email = useSelector((state: RootState) => state.cancellationWorkflow.email);
  const confirmationCode = useSelector((state: RootState) => state.cancellationWorkflow.reservation?.data?.attributes?.confirmation_code);
  const legacyReservationId = useSelector((state: RootState) => state.cancellationWorkflow.reservation?.data?.attributes?.legacy_reservation_id);

  const handleRecipientEmails = (e: PillsInputCallbackType) => {
    dispatch(setEmailData({...email?.data, recipientsEmails: e.items}));
  };

  return (
    <div className={style.headerEmail}>
      <div className={style.emailContacts}>
        <span className={style.titleEmails}>To:</span>
        <PillsInput
          pillComponent={Badge}
          pillTextField={"text"}
          pillCallbackDeleteField={"handleClose"}
          initialPillsProps={
            reservation?.data?.attributes?.guestInformation?.email
              ? [
                  {
                    disabled: true,
                    closeButton: false,
                    isPill: true,
                    variant: "default",
                    outline: false,
                    text: reservation?.data?.attributes?.guestInformation?.email,
                  },
                ]
              : []
          }
          pillValidProps={{
            disabled: false,
            closeButton: true,
            isPill: true,
            variant: "default",
            outline: false,
          }}
          pillInvalidProps={{
            disabled: false,
            closeButton: true,
            isPill: true,
            variant: "error",
            outline: false,
          }}
          allowDuplicated={false}
          typeValidator={"email"}
          callbackState={handleRecipientEmails}
          inputPlaceholder={"add recipient"}
        />
      </div>
      <div>
        <span className={style.titleEmails}>Subject: </span>
        Vacasa Reservation Cancellation {confirmationCode ?? legacyReservationId}
      </div>
    </div>
  );
};
